module.exports = __webpack_public_path__ + "static/media/IMG_7008 edit.6f39a804.jpg";